import React from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Row,
  Col,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  Form,
  FormGroup,
  FormFeedback
} from 'reactstrap';
import Button from '../../shared/Button';
import styles from './styles.scss';


const MIN_QUERY_LENGTH = 3;
const MAX_QUERY_LENGTH = 100;

export default class CompaniesListFilter extends React.Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.switchActiveFilter = this.switchActiveFilter.bind(this);
  }

  static get propTypes() {
    return {
      onSubmit: PropTypes.func,
      onChangeFilter: PropTypes.func,
      query: PropTypes.string,
      enabled: PropTypes.bool,
    }
  }

  get isValid() {
    const { query } = this.props;
    return !query || (
      query.length >= MIN_QUERY_LENGTH &&
      query.length <= MAX_QUERY_LENGTH
    );
  }

  onSubmit(e) {
    e.preventDefault();
    this.props.onSubmit(1);
  }

  switchActiveFilter(e) {
    const {
      enabled,
      onChangeFilter,
    } = this.props;
    const value = e.target.value === 'active';

    onChangeFilter('enabled', enabled === value ? null : value)
  }

  render() {
    const {
      query,
      enabled,
      onChangeFilter
    } = this.props;
    return (
      <Container fluid={true} className='col-md-12 col-lg-9 col-md-offset-2'>
        <Form onSubmit={this.onSubmit}>
          <Row>
            <Col lg={12} className='mb-2'>
              <FormGroup>
                <InputGroup>
                  <InputGroupAddon addonType='prepend'>
                    <InputGroupText className={styles.searchIcon}>
                      <i className='fa fa-search' />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input className={styles.search}
                    value={query}
                    placeholder='Search by Company name, Customer Number, Address and Postal Code'
                    onChange={(event) => onChangeFilter('query', event.target.value)}
                    invalid={!this.isValid}
                  />
                  <FormFeedback className='text-left'>
                    {`Search query should contain from ${MIN_QUERY_LENGTH} to ${MAX_QUERY_LENGTH} characters`}
                  </FormFeedback>
                </InputGroup>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={10} className='mb-2 text-left'>
              <div className='d-flex align-items-center'>
                <span className='font-weight-bold mr-3'>Status:</span>
                <input
                  className='mr-1'
                  type='radio'
                  name='status'
                  checked={enabled}
                  value='active'
                  id='active'
                  onClick={this.switchActiveFilter}
                />
                <label htmlFor='active' className='ml-1 mr-3 mt-2'>Active</label>
                <input
                  className='mr-1'
                  type='radio'
                  name='status'
                  checked={enabled === false}
                  id='inactive'
                  value='inactive'
                  onClick={this.switchActiveFilter}
                />
                <label htmlFor='inactive' className='ml-1 mr-3 mt-2'>Inactive</label>
              </div>
            </Col>
            <Col md={2} className='mb-2'>
              <Button
                type='submit'
                kind='danger'
                className={`w-100 ${styles.submitButton}`}
                disabled={!this.isValid}>
                  Submit
              </Button>
            </Col>
          </Row>
        </Form>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// src/components/companiesList/CompaniesListFilter/index.jsx